import {BarsOutlined, LoadingOutlined, UnlockOutlined, UserOutlined} from "@ant-design/icons";
import React, {useCallback} from "react";

import {LoginViewStore} from "../view-store";
import {Api} from "../api/api";


const items = [
    {
        icon: <UserOutlined style={{fontSize: 20}}/>,
        percent: 0,
    },
    {
        icon: <BarsOutlined style={{fontSize: 20}}/>,
        percent: 50,
    },
    {
        icon: <UnlockOutlined style={{fontSize: 20}}/>,
        percent: 100,
    }
]


const setLoading = (loading) => {
    LoginViewStore.update(s => {
        s.loading = loading;
    })
}

const resetIsCourse = () => {
    LoginViewStore.update(s => {
        s.isCourse = false;
    })

}

const setError = (error) => {
    LoginViewStore.update(s => {
        s.error = error;
    })
}

const setSecureEmail = (secureEmail) => {
    LoginViewStore.update(s => {
        s.secureEmail = secureEmail;
    })
}


export const useActions = () => {
    const loginMethod = LoginViewStore.useState(s => s.loginMethod);
    const email = LoginViewStore.useState(s => s.email);
    const member = LoginViewStore.useState(s => s.member);
    // const magicLink = LoginViewStore.useState(s => s.magicLink);
    const sendMagicLink = useCallback(async (magicLink, memberId) => {
        // console.log('[[action 2 -> sendMagicLink]]', {email, member, memberId, magicLink});
        setLoading(true);
        if (magicLink) {
            const {error, secureEmail, success, users} = await Api.sendMagicLink({
                email,
                member: member || memberId,
            });

            // console.log('[[action 2 -> sendMagicLink: isMagicLink]]', {error, secureEmail, success});

            if (error) {
                setError("email-not-found");
            } else if (users) {
                LoginViewStore.update(
                    s => {
                        s.users = users;
                        s.selectUsers = true;
                        s.selectUsersAction = (member) => sendMagicLink(true, member);
                    }
                )
            } else if (success) {
                setSecureEmail(secureEmail);
                LoginViewStore.update(s => {
                    s.current = 2;
                });
            }
        } else {
            LoginViewStore.update(s => {
                s.current = 2;
            });
        }

        setLoading(false);
    }, [email, member]);
    return [
        useCallback(async () => {
            // console.log('[[action 1 -> checkMember]]', {loginMethod, email, member});
            const apiCall = loginMethod === 'member' ? Api.checkMemberById : Api.checkMemberByEmail;
            const value = loginMethod === 'member' ? member : email;
            setLoading(true);
            setError(null);
            resetIsCourse();
            // console.log('[[call]]', {loginMethod, value});

            await apiCall(value).then(
                ({exists, course, error}) => {

                    if (error) {
                        setError("user-not-found");
                    } else if (exists) {
                        LoginViewStore.update(s => {
                            s.isCourse = course;
                            s.current = course ? 2 : 1;
                        });
                    } else {
                        setError('Member not found');
                    }
                }
            )
            setLoading(false);

        }, [loginMethod, email, member]),

        sendMagicLink,
    ]
}

export const useStepsProps = () => {
    const {current, loading, active} = LoginViewStore.useState();
    const actions = useActions();
    return {
        items: items.map((item, index) => {
            if (index === current && loading) {
                return {
                    ...item,
                    status: active === current ? 'process' : active < current ? 'wait' : 'finish',
                    icon: <LoadingOutlined/>
                }
            }
            return item;
        }),
        size: 'small',
        direction: 'horizontal',
        responsive: false,
        next: (p) => {
            // console.log('[[next]]', {current});
            setError(null);
            actions[current](p);
        },
        prev: () => {
            LoginViewStore.update(s => {
                s.error = null;
                s.current = s.current - 1;
            });
        },
        current
    };
}
